<template>
  <div class="ListPanel">
    <HeaderSection 
      :title="title"
      :closeLinkTo="{ name: 'home'}">
      <p>
        ... Lijst met platforms &amp; bronnen. <br />
        ... Zie slider over kaart <br />
        ... Misschien andere weergave dan andere lijsten?
      </p>
    </HeaderSection>

    <List 
      :items="items" 
      :sortingBy="sortingBy" 
      type="platforms" />

  </div>
</template>

<script>
import List from '@/components/lists/List';
import HeaderSection from '@/components/section/HeaderSection';

export default {
  name: 'ListPlatforms',
  components: {
    List,
    HeaderSection
  },
  data() {
    return {
      title: 'Platforms & Bronnen',
      sortingBy: [
        
      ],
      items: [
        
      ]
    }
  }
}
</script>

<style lang="scss">

  .ListPanel {
    height: 100%;
    display: flex;
    flex-direction: column;

    .List {
      width: 100%;
      flex-grow: 1;
    }
  }

</style>
